export function getLogger(
  enabled = false,
  prefix = "Unspecified Logger Prefix"
) {
  const buildPrefix = () => "[" + prefix + "] ";
  return {
    info: function (...args) {
      if (enabled) {
        console.log(buildPrefix(), ...args);
      }
    },
    warn: function (...args) {
      if (enabled) {
        console.warn(buildPrefix(), ...args);
      }
    },
    error: function (err) {
      if (enabled) {
        console.error(buildPrefix(), err);
      }
    },
  };
}
